import { BrowserRouter, Routes, Route } from "react-router-dom"
import Layout from "@/components/Layout"
import Home from "@/pages/Home"
import QuemSomos from "@/pages/QuemSomos"
import Valores from "@/pages/Valores"
import Blog from "@/pages/Blog"
import Contato from "@/pages/Contato"
import MetodoGO from "@/pages/MetodoGO"
import TesteDeNivel from "@/pages/TesteDeNivel"
import Produtos from "@/pages/Produtos"
import ProjetosSociais from "@/pages/ProjetosSociais"
import Convenios from "@/pages/Convenios"
import Certificados from "@/pages/Certificados"
import TimeAtletas from "@/pages/TimeAtletas"
import InstitutoPonte from "@/pages/InstitutoPonte"
import EWPass from "@/pages/EWPass"
import Afiliado from "@/pages/Afiliado"
import Parceiro from "@/pages/Parceiro"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/valores-organizacionais" element={<Valores />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/fale-conosco" element={<Contato />} />
          <Route path="/metodo-go" element={<MetodoGO />} />
          <Route path="/teste-de-nivel" element={<TesteDeNivel />} />
          <Route path="/nossos-produtos" element={<Produtos />} />
          <Route path="/projetos-sociais" element={<ProjetosSociais />} />
          <Route path="/nossos-convenios" element={<Convenios />} />
          <Route path="/certificados" element={<Certificados />} />
          <Route path="/time-de-atletas-ew" element={<TimeAtletas />} />
          <Route path="/projetos-sociais-instituto-ponte" element={<InstitutoPonte />} />
          <Route path="/ewpass-plano-de-assinatura" element={<EWPass />} />
          <Route path="/seja-um-afiliado" element={<Afiliado />} />
          <Route path="/seja-nosso-parceiro" element={<Parceiro />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
